import axios from "axios";
import { EColors } from "common/styles";
import { Button } from "components/buttons";
import { InputField } from "components/input";
import { TextareaField } from "components/input/Input/TextareaField";
import { Styled } from "components/Styled";
import { Formik } from "formik";
import { ContactSchema } from "./ContactSchema";
import { ERROR_MES, SUCCESS_MES, initialValues } from "./data";
import {
  FormWrapper,
  InputBoxWrapper,
  TextareaBoxWrapper,
} from "./styled";
import { TForm, TFormProps } from "./types";

export const Form = ({ message, setMessage }: TForm) => {
  const onSubmitData = (
    values: TFormProps,
    /* eslint-disable */
    { resetForm }: { resetForm: any }
  ) => {
    const data = {
      name: values.name,
      phone: values.phone,
      description: values.description,
    };
   
    console.log(data);

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("phone", data.phone);
    formData.append("description", data.description);


    axios({
      method: "post",
      url: 'https://mailer.kitg.com.ua/egg/mail.php',
      data: formData,
    })
      .then((response) => {
        console.log(response.data);
        setMessage(SUCCESS_MES);
        return response.data;
      })
      .catch((error) => {
        setMessage(ERROR_MES);
        console.log("error: ", error.message);
      });

    resetForm({ values: initialValues });
  };

  return (
    <>
      {message !== "" ? (
        <Styled.FlexWrapper>
          <Styled.H3
            color={message === ERROR_MES ? EColors.red : EColors.accent_300}
          >
            {message}
          </Styled.H3>
        </Styled.FlexWrapper>
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={ContactSchema}
          onSubmit={onSubmitData}
        >
          {({ values, handleChange, handleSubmit }) => (
            <FormWrapper onSubmit={handleSubmit}>
              <InputBoxWrapper>
                <InputField
                  type="text"
                  name="name"
                  label="Ім'я"
                  onChange={handleChange}
                  value={values.name}
                />
                <InputField
                  type="tel"
                  name="phone"
                  label="Телефон"
                  onChange={handleChange}
                  value={values.phone}
                />
              </InputBoxWrapper>
              <TextareaBoxWrapper>
                <TextareaField
                  name="description"
                  label="Повідомлення..."
                  value={values.description}
                />
              </TextareaBoxWrapper>
              <Button
                type="submit"
                title="Надіслати"
                width="100%"
                height="60px"
              />
            </FormWrapper>
          )}
        </Formik>
      )}
    </>
  );
};
